import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css/animate.min.css";
import "./custom.css";
import "./responsive.css";
import Router from './router/NavRouter';
import SEO from "./helper/SEO";
import { ToastContainer } from 'react-toastify';
import { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { BaseUrl } from './helper/BaseUrl';
import { HelmetProvider } from 'react-helmet-async';

function App({ initialData, initialSeo }) {
  const [seoData, setSeoData] = useState(null);
  const location = useLocation();
  // seo 
  const Detailfetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/seo${location.pathname}`, {
        method: 'GET',
      });
      const result = await response.json();
      if (result.data === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setSeoData(result.data);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };

  useEffect(() => {
    Detailfetcher();
  }, [location.pathname])

  // 

  useEffect(() => {
    if (!sessionStorage.getItem("first_landing_url")) {
      sessionStorage.setItem("first_landing_url", window.location.href);
    }
  }, []);


  const NormalizeTrailingSlash = () => {
    useEffect(() => {
      if (location.pathname !== '/' && location.pathname.endsWith('/')) {
        window.history.replaceState(
          null,
          '',
          location.pathname.slice(0, -1) + location.search + location.hash
        );
      }
    }, []);

    return null;
  };

  return (
    <HelmetProvider>
      <div className="App">
        <NormalizeTrailingSlash />
        <SEO seoData={seoData} initialSeo={initialSeo} />
        <Router />
        <ToastContainer />
      </div>
    </HelmetProvider>
  );
}

export default App;
